// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3LUAC","col":"CardReaderDesc_col__tx5f0","label":"CardReaderDesc_label__3DKr-"};